import { useCallback } from "react";
import { useSubscriptionProcessActions } from "../contexts/SubscriptionProcessContext";
import { useSubscriptionProcessState } from "../contexts/selectors/selectors";

/**
 * Hook to refresh the subscription process state from the backend.
 * Use this after any mutation that might change the step status
 * (e.g., adding an insured, completing pricing, etc.)
 */
export const useRefreshSubscriptionProcess = () => {
  const { fetchSubscriptionProcess } = useSubscriptionProcessActions();
  const { riskId } = useSubscriptionProcessState();

  const refresh = useCallback(async () => {
    if (riskId) {
      await fetchSubscriptionProcess(riskId);
    }
  }, [fetchSubscriptionProcess, riskId]);

  return { refresh };
};
